// WorkoutService: API client for user workouts
import { Workout } from '../models/Workout';
import { StrongFoundationService } from './StrongFoundationService';
import { getLocaleCode } from '../utils/Utilities';
import { DateTime } from 'luxon';

const PAGE_SIZE = 20;

export class WorkoutService extends StrongFoundationService {
  public async fetchUserWorkouts(userId: string, isOwner: boolean, afterDate = DateTime.utc().toMillis(), skip = 0): Promise<Workout[]> {
    try {
      const page = Math.floor(skip / PAGE_SIZE);
      const response = await this.get<Workout[]>(`exercise/workout/user`, {
        userId,
        afterDate,
        skip: page,
        language: getLocaleCode(),
      });
      return response ?? [];
    } catch {
      return [];
    }
  }
}

export const workoutService = new WorkoutService();
